<template>
  <div>
    <component :is="$route.meta.layout || 'div'">
      <router-view></router-view>
    </component>

    <!-- 공통 팝업 -->
    <Dialog
      v-model:visible="popupView"
      modal
      header="&nbsp;"
      class="custom-dialog newsletter-popup"
    >
      <!-- <div class="content">
        <h3>
          <img src="@/assets/img/newsletter_icon.png" alt="" />
        </h3>
        <p>
          Stay up to date on the latest <br />
          #KOREADERMA news
        </p>

        <form action="">
          <div class="form-group">
            <input
              type="text"
              v-model="username"
              class="flex-auto"
              autocomplete="off"
              placeholder="Name"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model="email"
              class="flex-auto"
              autocomplete="off"
              placeholder="Your email address"
            />
          </div>
        </form>
      </div> -->
      <div class="content">
        <button type="button" class="modal_close" @click="closepopup">
          <i class="pi pi-times"></i>
        </button>
        <div class="image-wrapper">
          <img src="@/assets/img/newpopup.jpg" alt="" />

          <!-- <a
            href="https://xn--vb0bz3y9vbc6qsyab49c.com/vod/en"
            target="_blank"
            class="clickable-area"
          ></a> -->
        </div>
      </div>
      <!-- <div class="btnbox">
        <button type="button" @click="subscribe()" class="subscribe-btn">
          <span>SUBSCRIBE</span>
        </button>
      </div> -->
      <div class="modalfooter">
        <label for="notopen" @click="hidePopupForToday">
          Do not open for a day
        </label>
        <input type="checkbox" @click="hidePopupForToday" id="notopen" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "primevue/dialog";
import { supabase } from "@/API/supabase";

export default {
  name: "코리아더마2025",
  data() {
    return {
      popupView: false,
      email: "",
      username: "",
    };
  },
  components: {
    Dialog,
  },
  mounted() {
    // localStorage.removeItem('koreaderma_hidePopupDate');
    const storedDate = localStorage.getItem("koreaderma_hidePopupDate");
    if (storedDate === this.getTodayDate()) {
      this.popupView = false; // 저장된 날짜가 오늘과 같으면 팝업 숨김
    } else {
      this.popupView = true;
    }
  },
  methods: {
    // 구독하기
    async subscribe() {
      if (this.username === "") {
        alert("Please enter your name.");
        return;
      }
      if (this.email === "") {
        alert("Please enter your email address.");
        return;
      }
      if (!this.validateEmail()) {
        alert("Please enter a valid email address.");
        return;
      }

      // 이메일 중복 체크
      const { data: existingEmail, error: emailError } = await supabase
        .from("Subscribe")
        .select("email")
        .eq("email", this.email);
      if (emailError) {
        console.error("이메일 중복 체크 오류:", emailError);
        return;
      }
      if (existingEmail.length > 0) {
        alert("This email address is already subscribed.");
        return;
      }

      const { data, error } = await supabase
        .from("Subscribe")
        .insert([{ email: this.email, name: this.username }])
        .select("*");

      if (error) {
        console.error("구독하기 오류:", error);
      } else {
        alert("Thank you for subscribing!");
        this.hidePopupForToday();
      }
    },

    // 이메일 유효성검사
    validateEmail() {
      const emailPattern = /^[A-Za-z0-9_.\-]+@[A-Za-z0-9\-]+(\.[A-Za-z]{2,})+$/;
      if (!emailPattern.test(this.email)) {
        return false;
      }
      return true;
    },

    // 팝업창 오늘 하루 보지 않기
    hidePopupForToday() {
      localStorage.setItem("koreaderma_hidePopupDate", this.getTodayDate());
      this.popupView = false;
    },

    // 오늘 날짜 구하기
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = today.getDate();
      // 날짜 형식 YYYY-MM-DD
      return `${year}-${month < 10 ? "0" + month : month}-${
        day < 10 ? "0" + day : day
      }`;
    },

    // 팝업창 닫기
    closepopup() {
      this.popupView = false;
    },
  },
};
</script>

<style scoped>
.image-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.clickable-area {
  position: absolute;
  /* 이미지 비율에 맞춰 % 단위로 지정 */
  top: 87.5%;
  left: 37%;
  width: 26%;
  height: 4.5%;
  cursor: pointer;
  /* background: rgba(255, 0, 0, 0.3); */
}

.clickable-area:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>
